import { useWallet } from 'solana-wallets-vue';
import { ref, Ref, watch } from 'vue';
import { NetworkIdType, PortfolioElementMultipleData, TokenInfo } from '@sonarwatch/portfolio-core';
import { stakingFetch } from '@/api/apiMain';
import { useDataStore } from '@/store/data';

const isFetching = ref(false);
const finished = ref(false);
const stakedAmount: Ref<number | null> = ref(null);

export function useStakedAmount() {
  const { publicKey } = useWallet();
  const dataStore = useDataStore();

  watch(publicKey, async (newPublicKey) => {
    if (!newPublicKey) {
      stakedAmount.value = null;
      finished.value = false;
      return null;
    }
    await execute()
  })

  const execute = async () => {
    if (!publicKey.value) {
      stakedAmount.value = null;
      finished.value = false;
      return;
    }

    isFetching.value = true;

    await stakingFetch(
      publicKey.value.toString(),
      'solana',
    ).then((r) => {
      const assets = r.elements.filter(e => e.platformId === "native-stake").map(e => {
        return (e.data as PortfolioElementMultipleData).assets.filter(a => a.name === 'SonarWatch')
      }).flat();
      stakedAmount.value = assets.reduce((acc, current) => {
        return current.data.amount ? current.data.amount + acc : acc;
      }, 0)

      if (r.tokenInfo) {
        for (const [networkId, tokenInfoRecord] of Object.entries(r.tokenInfo)) {
          if (tokenInfoRecord) {
            dataStore.pushTokenInfos(networkId as NetworkIdType, new Map<string, TokenInfo>(
              Object.entries(tokenInfoRecord)
            ))
          }
        }
      }
      isFetching.value = false;
      finished.value = false;
    });
  }

  return {
    stakedAmount,
    isFetching,
    finished,
    execute
  }
}
